import React, { Suspense } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { useSegment } from '@sparknz/journeys-common';

import { BottomBarMpdPromotionsQuery } from '__generated__/BottomBarMpdPromotionsQuery.graphql';
import { getOfferIds } from 'components/shop/MobilePlans/utils/getOfferIds.utils';
import { useSelectedPlans } from '../../providers';
import { MobilePlansDetails } from '../../typings/plans';
import BottomBarActions from './BottomBarActions';
import BottomBarContainer from './BottomBarContainer';
import BottomBarLoader from './BottomBarLoader';
import BottomBarSelectionDetails from './BottomBarSelectionDetails';

export const mpdPromotionsQuery = graphql`
  query BottomBarMpdPromotionsQuery(
    $offerIds: [String!]!
    $channel: CartChannel!
  ) {
    mpdPromotions(offerIds: $offerIds, channel: $channel) {
      price {
        basePrice
        basePriceExcludingTax
        effectivePrice
        effectivePriceExcludingTax
        discount {
          appliedValue
          appliedValueExcludingTax
          discountedValue
          discountedValueExcludingTax
        }
      }
      bundles {
        id
        items {
          id
          price {
            basePrice
            basePriceExcludingTax
            effectivePrice
            effectivePriceExcludingTax
            discount {
              appliedValue
              appliedValueExcludingTax
              discountedValue
              discountedValueExcludingTax
            }
          }
          productOfferingId
        }
      }
    }
  }
`;

interface BottomBarProps {
  planCardsProducts: MobilePlansDetails;
  openSelectedPlansLayer(): void;
}

function BottomBarInternal({
  planCardsProducts,
  openSelectedPlansLayer,
}: BottomBarProps) {
  const { selectedPlans } = useSelectedPlans();
  const { channel } = useSegment();

  const isTeamUpPlanAvailable = planCardsProducts.some((plan) => {
    return plan.planDetails.isTeamUpEligible;
  });

  const { mpdPromotions } = useLazyLoadQuery<BottomBarMpdPromotionsQuery>(
    mpdPromotionsQuery,
    {
      channel,
      offerIds: getOfferIds(selectedPlans),
    },
  );

  const isPlanSelected = selectedPlans.length > 0;
  if (!isPlanSelected) {
    return null;
  }

  return (
    <BottomBarContainer>
      <div>
        <BottomBarSelectionDetails
          mpdPromotions={mpdPromotions}
          showTeamUpPromotion={isTeamUpPlanAvailable}
        />
        <BottomBarActions
          openMpdSelectionActionLayer={openSelectedPlansLayer}
          planCardsProducts={planCardsProducts}
        />
      </div>
    </BottomBarContainer>
  );
}
const BottomBar = (props: BottomBarProps) => {
  return (
    <Suspense fallback={<BottomBarLoader />}>
      <BottomBarInternal {...props} />
    </Suspense>
  );
};

export default BottomBar;
